import { useState, useEffect } from 'react';

const BREAKPOINT = 960;

/**
 * Hook que retorna la cantidad inicial de resultados según el ancho de pantalla
 * @returns {number} 4 si el ancho es <= 960px, 3 en caso contrario
 */
export const useInitialResults = () => {
  const [initialResults, setInitialResults] = useState(
    window.innerWidth <= BREAKPOINT ? 4 : 3
  );

  useEffect(() => {
    const handleResize = () => {
      setInitialResults(window.innerWidth <= BREAKPOINT ? 4 : 3);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return initialResults;
};
